import { useApi, apiPatch } from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { LoadingBlock, ErrorState } from "@/components/common/StateViews";
import { SeverityChip } from "@/components/common/SeverityChip";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { fmtNum, VENDOR_LABEL } from "@/lib/format";
import { toast } from "sonner";
import { MoreHorizontal } from "lucide-react";

export default function AppsInventory() {
  const { data: apps = [], isLoading, error, refetch } = useApi("apps", "/apps");
  const setStatus = async (a, status) => { await apiPatch(`/apps/${a.id}`, { status }); toast.success(`${a.name} → ${status}`); refetch(); };
  if (error) return <ErrorState />;
  const riskColor = (r) => (r >= 75 ? "danger" : r >= 45 ? "warning" : "success");

  return (
    <div>
      <PageHeader eyebrow="Navitra Guard" title="AI Apps Inventory" subtitle="Every discovered AI app merged from Defender, extension, SSE and OAuth grants — with a single sanction status." />
      <Card>
        <CardContent className="p-0">
          {isLoading ? <div className="p-6"><LoadingBlock /></div> : (
            <Table>
              <TableHeader><TableRow><TableHead>App</TableHead><TableHead>Vendor</TableHead><TableHead>Risk</TableHead><TableHead className="text-right">Users 30d</TableHead><TableHead className="text-right">Data</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Set status</TableHead></TableRow></TableHeader>
              <TableBody>
                {apps.map((a) => (
                  <TableRow key={a.id} data-testid={`app-${a.id}`}>
                    <TableCell><p className="font-medium">{a.name}</p><p className="text-xs text-muted-foreground max-w-xs truncate">{a.notes}</p></TableCell>
                    <TableCell className="text-muted-foreground text-sm">{VENDOR_LABEL[a.vendor]}</TableCell>
                    <TableCell><SeverityChip level={riskColor(a.risk_score)} label={`${a.risk_score}`} dot /></TableCell>
                    <TableCell className="text-right mono">{fmtNum(a.users_30d)}</TableCell>
                    <TableCell className="text-right mono text-xs">{fmtNum(a.data_volume_mb)} MB</TableCell>
                    <TableCell><SeverityChip level={a.status} /></TableCell>
                    <TableCell className="text-right">
                      <DropdownMenu>
                        <DropdownMenuTrigger asChild><Button variant="ghost" size="icon" data-testid={`app-menu-${a.id}`}><MoreHorizontal className="h-4 w-4" /></Button></DropdownMenuTrigger>
                        <DropdownMenuContent align="end">
                          <DropdownMenuItem onClick={() => setStatus(a, "sanctioned")}>Sanction</DropdownMenuItem>
                          <DropdownMenuItem onClick={() => setStatus(a, "tolerated")}>Tolerate</DropdownMenuItem>
                          <DropdownMenuItem onClick={() => setStatus(a, "blocked")} className="text-sev-danger">Block</DropdownMenuItem>
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
